import { makeStyles } from 'lib/components';

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    padding: '24px',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    borderBottom: '1px solid #C8CDD7',
    width: '100%',
  },

  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0px',
    width: '100%',
  },

  header: {
    flex: '1 1 0',
    color: '#000',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '18px',
    paddingTop: '8px',
    paddingBottom: '8px',
  },

  formContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },

  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    width: '100%',
    '@media (min-width: 640px)': {
      flexDirection: 'row',
    },
  },

  fieldContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },

  textInput: {
    minWidth: '163px',
    textWrap: 'wrap',
    '& > .Mui-error > fieldset': {
      borderColor: `${theme.evPalette.rose[900]} !important`,
    },
    '& .myev-MuiInputBase-input': {
      height: '0.6em',
    },
    '@media (min-width: 640px)': {
      textWrap: 'no-wrap',
    },
    '& .myev-MuiFormHelperText-root': {
      color: `${theme.evPalette.rose[900]} !important`,
      marginLeft: '0px',
    },
  },

  label: {
    fontSize: '1rem',
    color: theme.evPalette.charcoal[800],
    marginBottom: theme.spacing(1),
    '&.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    '& .myev-MuiFormLabel-asterisk.Mui-error': {
      color: `${theme.evPalette.rose[900]} !important`,
    },
    width: 'fit-content',
  },

  asterisk: {
    color: theme.evPalette.rose[900],
  },

  inputHelperText: {
    color: `${theme.evPalette.rose[900]} !important`,
  },

  button: {
    height: '44px',
    width: '100%',
    padding: '10px 16px',
    '@media (min-width: 640px)': {
      width: '89px',
    },
  },

  srsInfoLabelContainer: {
    display: 'flex',
    width: '100%',
    gap: '24px',
  },
  srsInfoLabelContentContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: '8px',
    justifyContent: 'space-between',
  },
  srsInfoLabelContentElement: {
    display: 'flex',
    flexDirection: 'column',
    width: '35%',
    gap: '6px',
    justifyContent: 'flex-end',
  },

  srsInfoDetailsTitleText: {
    color: theme.evPalette.charcoal[800],
    fontFamily: 'Noto Sans',
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '18px',
  },
  srsInfoDetailsValueText: {
    color: '#000000',
    fontFamily: 'Noto Sans',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
  },
}));
